import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';

const StylesProvider = styled.article`
  width: 650px;
  margin: 0 auto;
  padding: 30px;
  text-align: center;

  font-family: Montserrat, Helvetica, Arial, sans-serif;
  color: var(--color-text);

  --color-text: #09111c;

  h1 {
    color: var(--color-text);
    font-size: 3.5em;
    margin: 0.5em 0 0;
  }
  b {
    color: slategray;
  }

  h2 {
    color: var(--color-text);

    b {
      color: slategray;
    }
  }

  a {
    color: var(--color-text);
    text-decoration: underline;

    &:hover,
    &:active,
    &:focus {
      opacity: 0.8;
    }
  }
`;

export const Maintenance = () => {
  const { t } = useTranslation('common');
  return (
    <StylesProvider>
      <title>{t('Site Maintenance')}</title>
      <h1>{t('Site Maintenance')}</h1>
      <img src="https://assets.hbsuk.co.uk/img/login-illustration.svg" alt={t('Virtual Lucy')} />
      <h2>We&rsquo;ll be back soon...</h2>
      <p>
        Sorry for the inconvenience but we&rsquo;re performing some planned maintenance at the moment. If you need to
        you can always <a href="mailto:support@hbsuk.co.uk">{t('contact us')}</a>, otherwise we&rsquo;ll be back online
        shortly.
      </p>
    </StylesProvider>
  );
};
